module.exports = __webpack_public_path__ + "static/media/goldMedal.f2f58656.svg";